export default function getTrackProductCategoryViewRequestObject(options: { idPath: string }) {
  return new Promise((resolve, reject) => {
    if (options.idPath) {
      resolve({
        idPath: [options.idPath],
      });
    } else {
      reject("idPath is required");
    }
  });
}
